export enum MenuLabels {
  USER_ACCOUNTING = 'user-accounting',
  WITHDRAW = 'withdraw',
}
